import type { ReactNode } from 'react';
import { Moon, Sun } from 'lucide-react';
import clsx from 'clsx';
import { UserMenu } from './UserMenu';
import { NotificationBell } from './NotificationBell';
import { useTheme } from '@/lib/theme';

interface Props {
  title: string;
  action?: ReactNode;
}

export function PageHeader({ title, action }: Props) {
  return (
    <div className="flex items-center justify-between px-7 py-3 border-b border-border bg-panel">
      <h1 className="text-base font-bold tracking-tight">{title}</h1>
      <div className="flex items-center gap-2">
        {action}
        <NotificationBell />
        <ThemeToggleButton />
        <UserMenu />
      </div>
    </div>
  );
}

function ThemeToggleButton() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const Icon = isDark ? Sun : Moon;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Mudar pra tema claro' : 'Mudar pra tema escuro'}
      title={isDark ? 'Tema claro' : 'Tema escuro'}
      className={clsx(
        'w-8 h-8 flex items-center justify-center rounded-full',
        'text-muted hover:text-text hover:bg-panel-2 transition-colors',
      )}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
